"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushEnvironment = exports.popEnvironment = exports.replaceEnvironment = exports.currentEnvironment = exports.createBlockEnvironment = void 0;
const lodash_1 = require("lodash");
function createBlockEnvironment(context, name = 'blockEnvironment', head = {}) {
    return {
        name,
        tail: currentEnvironment(context),
        head,
        id: (0, lodash_1.uniqueId)()
    };
}
exports.createBlockEnvironment = createBlockEnvironment;
function currentEnvironment(context) {
    return context.runtime.environments[0];
}
exports.currentEnvironment = currentEnvironment;
function replaceEnvironment(context, environment) {
    context.runtime.environments[0] = environment;
}
exports.replaceEnvironment = replaceEnvironment;
function popEnvironment(context) {
    return context.runtime.environments.shift();
}
exports.popEnvironment = popEnvironment;
function pushEnvironment(context, environment) {
    context.runtime.environments.unshift(environment);
}
exports.pushEnvironment = pushEnvironment;
//# sourceMappingURL=environment.js.map